export function titleCaseEnum(value: string): string {
  return value
    .split('_')
    .map((part) => (part.length === 0 ? part : part[0].toUpperCase() + part.slice(1)))
    .join(' ')
}

export function formatEnumList(values: readonly string[] | undefined): string | null {
  if (!values || values.length === 0) return null
  return values.map((value) => titleCaseEnum(value)).join(', ')
}

export function formatWaterFeature(value: string): string {
  switch (value) {
    case '0_12':
      return '0–12 inches'
    case '12_24':
      return '12–24 inches'
    case '24_36':
      return '24–36 inches'
    case '36_plus':
      return '36+ inches'
    case 'dry_field':
      return 'Dry Field'
    default:
      return titleCaseEnum(value)
  }
}
